var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFavouritedMutualGrid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFavouritedMutualGrid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.7%",
    y: "-6.9%",
    width: "119.4%",
    height: "119.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icFavouritedMutualGrid",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask-Copy-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.2387317,18.96306 L20.5098652,21.6233072 C20.3935243,21.736841 20.3401883,21.8999679 20.3676361,22.0599757 L21.0117222,25.815949 C21.068801,26.1459457 20.982403,26.4681447 20.7681235,26.7217243 C20.5532202,26.9768635 20.2406903,27.1234594 19.9110055,27.1234594 C19.7304119,27.1234594 19.5554326,27.0797925 19.39137,26.9933945 L16.0181054,25.2198964 C15.8774358,25.1465985 15.6999612,25.1459747 15.5589797,25.2198964 L12.1860271,26.9933945 C11.7219108,27.2373051 11.1414535,27.1169094 10.8089616,26.7217243 C10.594994,26.4681447 10.5082841,26.1465695 10.565363,25.815949 L11.2091372,22.0599757 C11.2365849,21.9002798 11.183249,21.736841 11.066908,21.6233072 L8.33804149,18.9633719 C8.03143779,18.6645659 7.92320637,18.2260259 8.05545456,17.8183646 C8.18801465,17.4107034 8.53360661,17.1193831 8.95748701,17.0579376 L12.7290556,16.5099185 C12.8896872,16.4865256 13.0287974,16.3857799 13.1005358,16.2401198 L14.7870121,12.8225646 C14.9763391,12.4386082 15.3606074,12.2 15.7885426,12.2 C16.2167896,12.2 16.601058,12.4386082 16.790385,12.8225646 L18.4765494,16.2398078 C18.5482878,16.385468 18.687086,16.4862137 18.8477176,16.5096066 L22.6192862,17.0576256 C23.0434785,17.1193831 23.3887586,17.4103914 23.5213187,17.8180527 C23.6535668,18.225714 23.5453354,18.664254 23.2387317,18.96306 Z M27.0685851,11.6164014 L25.6093823,13.0389115 C25.5471714,13.0996213 25.5186512,13.1868499 25.5333283,13.2724107 L25.8777395,15.2808369 C25.9082612,15.4572955 25.8620617,15.6295845 25.7474803,15.7651808 C25.6325654,15.901611 25.4654467,15.98 25.2891549,15.98 C25.1925863,15.98 25.0990199,15.9566501 25.0112909,15.9104506 L23.20751,14.9621105 C23.1322899,14.922916 23.0373892,14.9225825 22.9620023,14.9621105 L21.1583882,15.9104506 C20.910212,16.0408766 20.5998249,15.9764975 20.422032,15.7651808 C20.3076174,15.6295845 20.2612512,15.4576291 20.2917729,15.2808369 L20.6360173,13.2724107 C20.6506944,13.1870167 20.6221741,13.0996213 20.5599633,13.0389115 L19.1007604,11.6165682 C18.9368107,11.456788 18.8789363,11.2222882 18.9496531,11.0043001 C19.0205368,10.7863119 19.2053347,10.6305346 19.4319957,10.597678 L21.4487611,10.3046365 C21.5346554,10.2921277 21.6090416,10.2382561 21.6474022,10.1603674 L22.5492092,8.33290306 C22.6504478,8.1275906 22.855927,8 23.0847562,8 C23.3137521,8 23.5192314,8.1275906 23.6204699,8.33290306 L24.5221102,10.1602006 C24.5604708,10.2380893 24.6346901,10.2919609 24.7205845,10.3044698 L26.7373499,10.5975112 C26.9641777,10.6305346 27.1488088,10.7861451 27.2196924,11.0041333 C27.2904093,11.2221214 27.2325349,11.4566212 27.0685851,11.6164014 Z",
    id: "Combined-Shape",
    fill: "#10C2E1",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavouritedMutualGrid);
export default __webpack_public_path__ + "static/media/icFavouritedMutualGrid.278910fe6c19b7efe4b02b3b8f8c42e7.svg";
export { ForwardRef as ReactComponent };